<template>
    <section id="steps-uid-6-p-0" role="tabpanel" aria-labelledby="steps-uid-6-h-0" class="body current" aria-hidden="false">
        <form>
            <div class="row">
                <div class="col-md-12">
                    <p><b>{{offer.category | capitalize}} {{offer.type | capitalize}}</b> offer for <b>{{pricing.quantity}} {{pricing.unit.symbol}}</b> of <b>{{commodity.name}}</b> harvested in <b>{{commodity.year}}</b>.</p>
                    <p>Shipment will be made to/from <b>{{logistics.location.address.line1}} {{logistics.location.address.line2}}, {{logistics.location.address.city}}, {{logistics.location.address.state}}, {{logistics.location.address.country.name}} - {{logistics.location.address.postal_code}}</b>.</p>
                    <p>Freight type chosen is <b>{{logistics.freight.text | capitalize}}</b>. Storage type chosen is <b>{{logistics.storage | capitalize}}</b>.</p>
                    <p>Commodity will be shipped in <b>{{logistics.period.name}}</b> of <b>{{logistics.year}}</b>.</p>
                    <p><b>{{pricing.type | capitalize}}</b> contract @ <b>{{pricing.currency.symbol}} {{pricing.price}}</b> per <b>{{pricing.unit.symbol}}</b>.</p>
                    <p>Offer Expires on <b>{{offer.expires_at | date}}</b>.</p>
                </div>

            </div>
        </form>
    </section>
</template>

<script>
    export default {
        name: "Summary",
        data() {
            return {
                offer: this.$parent.offer,
                commodity: this.$parent.commodity,
                logistics: this.$parent.logistics,
                pricing: this.$parent.pricing
            }
        }
    }
</script>

<style scoped>

</style>
